module.exports = __webpack_public_path__ + "assets/img/28_976_big.b5f025fd.jpg";